<template>
  <div
    class="el-loading-mask myloading is-fullscreen"
    style="z-index: 2003;"
    v-if="show"
  >
    <div class="loading-center">
      <div class="sucesso-modal">
        <el-image
          :src="successIconUrl"
          class="sucesso-modal-image"
        />
        <h3
          class="sucesso-modal-title"
        >
          {{ titulo }}
        </h3>
        <p
          class="sucesso-modal-text"
        >
          {{ texto }}
        </p>

        <ButtonDefault
        :title="button"
        @click="emit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { successIcon } from '@/utils/ImageBucket'
import ButtonDefault from '@/components/buttons/ButtonDefault'

export default {
  name: 'SucessoModal',
  components: {
    ButtonDefault
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    button: {
      type: String,
      default: 'ACESSAR MINHA CONTA'
    },
    titulo: {
      type: String
    },
    texto: {
      type: String
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    successIconUrl () {
      return successIcon()
    }
  },
  methods: {
    emit () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.loading-center {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
}

.sucesso-modal {
  max-width: 315px;
  background: #FFFFFF;
  box-shadow: 0 2px 10px #0000000D;
  border-radius: 20px;
  padding: 30px 15px;
  height: fit-content;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.sucesso-modal-image {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

.sucesso-modal-text {
  margin: 0 0 5px;
  text-align: center;
  word-break: break-word;
}

.sucesso-modal-title {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  word-break: break-word;
  text-align: center;
}

.button-default {
  width: 100%;
}
</style>
